import { useEffect, useState } from 'react'

const MEDIA_QUERY = '(orientation: landscape) and (max-height: 600px)'

export default function LandscapeLock() {
  const [locked, setLocked] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(MEDIA_QUERY).matches
  })

  useEffect(() => {
    const mq = window.matchMedia(MEDIA_QUERY)
    const update = () => setLocked(mq.matches)
    update()
    mq.addEventListener('change', update)
    return () => mq.removeEventListener('change', update)
  }, [])

  useEffect(() => {
    if (!locked) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [locked])

  if (!locked) return null

  return (
    <div className="pointer-events-auto fixed inset-0 z-[10020] flex flex-col items-center justify-center gap-6 bg-oak-black px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-oak-yellow">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path
            d="M14 4l3 3M9 20H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 11v8a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1Z"
            stroke="currentColor"
            strokeWidth="1.75"
          />
          <path d="M3 10a8 8 0 0 1 7-7" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
        </svg>
      </div>
      <h2 className="font-serif text-[28px] leading-[1.05] tracking-[-0.8px] text-white">
        Rotate your device
      </h2>
      <p className="max-w-[320px] text-[14px] leading-[1.5] text-white/60">
        Oak is designed for portrait mode on mobile. Turn your device upright to keep going.
      </p>
    </div>
  )
}
